import { Breakpoint, Button, Color, Typography } from '@elearning-platform/ui';
import { styled } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding-top: 40px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const QuestionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ResultWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;

  @media ${Breakpoint.SmallDesktop} {
    flex-direction: row;
  }
`;

export const ResultContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 24px;
`;

export const ResultQuestionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ResultImageContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding-bottom: 16px;

  @media ${Breakpoint.SmallDesktop} {
    padding-bottom: 0;
  }
`;

export const ResultImage = styled.img`
  width: 100%;
  @media ${Breakpoint.SmallDesktop} {
    width: auto;
  }
`;

export const TryAgainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media ${Breakpoint.SmallDesktop} {
    gap: 40px;
    padding-top: 40px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const StyledButton = styled(Button)`
  align-self: baseline;
`;

export const StyledTypography = styled(Typography)`
  color: ${Color.Brand300};
`;
